// extracted by mini-css-extract-plugin
export default {"rolesTable":"RoleList_rolesTable__KK5+-"};